<template>
  <div>
    <b-tabs>
      <!--Notas de versão-->
      <b-tab>
        <template #title>
          <feather-icon icon="BookmarkIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Notas de versão</span>
        </template>
        <notasVersao />
      </b-tab>

      <!--FAQ - Peguntas Frequentes-->
      <b-tab>
        <template #title>
          <feather-icon icon="HelpCircleIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">FAQ - Peguntas frequentes</span>
        </template>
        <faq />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import { BTabs, BTab } from 'bootstrap-vue'
  import notasVersao from './centralapoioNotasVersao.vue'
  import faq from './caFaq.vue'

  export default {
    components: {
      BTabs,
      BTab,
      notasVersao,
      faq,
    },
    data() {
      return {
        options: JSON.parse(localStorage.getItem('userData')),
      }
    },
  }
</script>
